export enum State {
  OPTIONS = 'OPTIONS',
  WAITING_RESULTS = 'WAITING_RESULTS',
  RESULTS = 'RESULTS',
  MORE_RESULTS = 'MORE_RESULTS',
  ERROR = 'ERROR',
}

// revert to false before building
export const IS_DEV = false;

export enum TaskStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DONE = 'DONE',
}

export enum PUBLISH_EVENT {
  REGISTRATION = 'OpenRegistrationScreen',
}

export enum TaskError {
  INVALID_BATCH_SIZE = 'INVALID_BATCH_SIZE',
  INVALID_CAPTION = 'INVALID_CAPTION',
  BACKEND_FAILURE = 'BACKEND_FAILURE',
  BACKEND_TIMEOUT = 'BACKEND_TIMEOUT',
  FORBIDDEN_TEXT = 'FORBIDDEN_TEXT',
}

export enum ReqError {
  FORBIDDEN_TEXT = 'Input contains forbidden text',
}

export enum TaskItemStatus {
  ACCEPTED = 'ACCEPTED',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  FAILED_SERVER = 'FAILED_SERVER',
  FAILED_NSFW = 'FAILED_NSFW',
}

export const APP_API_URL = process.env.REACT_APP_API_URL;

export const DAILY_ALLOWANCE = 0;
export const POLLING_INTERVAL = 1000;
export const POLLING_TRIES = 24;

export const defaultConfig = {
  result_page_config: {
    is_multiselect_enabled: false,
    select_button_text: 'Select',
    generate_button_text: 'Show more results',
    done_button_text: 'Done',
    add_to_edit_button_text: 'Add to you edit',
    save_to_collection_button_text: 'Save to Collection',
    mature_info: 'Sensitive content hidden in line with our Community Guidelines',
    organize_button_text: 'Organize',
    tooltip_info: 'Information icon should explain how can I use the content',
  },
  entry_page_config: {
    title: 'AI Background creator',
    description: 'Describe the background you want to create',
    placeholder_text: 'Geometric Shapes',
    nsfw_stop_info: 'Stop Words',
    agreement_text: 'By continuing, you agree to our ',
    agreement_link: 'Generative AI Additional Terms of Use',
    select_color_text: 'Choose the main color',
    select_style_text: 'Choose a visual style',
    generate_button_text: 'Generate Background',
    invalid_caption_text: 'Reached the limit of words',
    reset_button_text: 'Reset',
    terms_of_services_key: 'terms_of_services_key',
    count_check_for_terms: 1,

    character_limitation: {
      // the longest prompt text has 272 characters
      count: 275,
      text: "Description can't exceed 275 characters",
    },
    restriction_config: {
      action: 'https://picsart.com/community-guidelines',
      action_title: 'Community Guidelines',
      text:
        'Some content related to your text input does not conform with our Community Guidelines. ' +
        'Picsart is committed to keeping our community safe, inclusive, and welcoming. ' +
        'For more information please review our %a.',
    },
    toggle_button: {
      more: 'more',
      showLess: 'Show less',
    },
    colors: {
      White: '#FFFFFF',
      Black: '#000000',
      'Coral-colored': '#E67464',
      Orange: '#E89368',
      'Bright yellow': '#F1DB69',
      'Forest green': '#74a71b',
      'Teal colored': '#19868F',
      'Dark blue': '#354372',
      'Navy blue': '#0E0F4F',
      'Pastel blue': '#88BEDD',
      'Bright red': '#df0c25',
      Magenta: '#E13AA1',
      Purple: '#AF4A86',
      'Dark purple': '#3E233C',
      Grey: '#A6A6A6',
      'Dark grey': '#555555',
    },
    bg_keywords: [
      'Gradient sky',
      'Floral repeat',
      'Geometrical Patterns',
      'Feather Texture',
      'Fruit',
      'Liquid bubbles',
      'Neon Style',
      'Water color',
      'Bokeh Natural',
      'Outline design',
      'Holly splashes',
      'Letter wallpaper',
    ],
    styles: [
      {
        title: 'Gradient',
        prompt: 'Gradient blurred minimalism abstract wallpaper background.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/44fa336b-5e8f-4b12-b4e1-2c08f950e02e.png',
        id: 0,
      },
      {
        title: 'Galaxy',
        prompt: 'A beautiful galaxy or celestial scene with stars and planets.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/d1b5135b-8235-4deb-9939-9f131e642238.png',
        id: 1,
      },
      {
        title: 'Marble',
        prompt: 'Marble pattern texture backgrounds.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/b42071e1-310b-4f2f-940e-12fc2eba6640.png',
        id: 2,
      },
      {
        title: 'Tye dye',
        prompt: 'Tye Dye background, Aesthetic soft tone colors.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/69e451f7-cb53-49a1-9ac9-4fba0083ee67.png',
        id: 3,
      },
      {
        title: 'Bokeh',
        prompt: 'Abstract blur background, with defocused bokeh lights.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/6bbc5272-6a14-47b2-91a9-468330762771.png',
        id: 4,
      },
      {
        title: 'Splash',
        prompt: 'An abstract minimalist background wallpaper of water splashes.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/fac0b38b-4675-4293-98da-144053bfb01e.png',
        id: 5,
      },
      {
        title: 'Geometric',
        prompt: ' A stylish and chic background featuring a pattern of abstract large brushstrokes, inspired by jackson pollock, monochromatic.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/b2a52177-414e-4ea1-8cf4-dd9d977c2d0c.png',
        id: 6,
      },
      {
        title: 'Abstract',
        prompt: 'Gradient blurred minimalism abstract wallpaper background.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/5fd734f5-d1d1-4f8b-a4a3-0f456aacbda7.png',
        id: 7,
      },
      {
        title: 'Splatter',
        prompt: 'abstract art piece with brushstrokes and splatters.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/9ee78802-2f32-43cd-8f3e-4e13e9542e2e.png',
        id: 8,
      },
      {
        title: 'Waves',
        prompt: 'water texture blue background, swirling pattern.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/6cec289b-2a37-409f-a2c7-6a3b10e98a0e.png',
        id: 9,
      },
      {
        title: 'Textured',
        prompt: 'colored background blurry , pattern texture of brushstrokes, soft',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/0482f2b5-db8c-4d78-8347-3eb5fdb02978.png',
        id: 10,
      },
      {
        title: 'Liquid Marble',
        prompt: 'Beautiful liquid marble texture with big oil bubbles, coloured abstraction with splashes.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/ede226bd-2d2a-4c9b-9355-b82458e165c9.png',
        id: 11,
      },
      {
        title: 'Organic Forms',
        prompt: 'An abstract painting that explores the interplay between bold, graphic shapes and more fluid, organic forms',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/5659866e-d360-4fa2-9102-3e8151c215d7.png',
        id: 12,
      },
      {
        title: 'Polygonal',
        prompt: 'Polygonal shape patterns with color shades, abstract geometric triangle patterned backgrounds.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/c1104a70-d647-49e9-b714-215d77519c9d.png',
        id: 13,
      },
      {
        title: 'Soft low poly',
        prompt: 'Geometric 3 d render, soft bright pastel, mountains surrounding, rule of thirds',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/a27ba09d-b4a4-41fd-8f98-437ab79afbe6.png',
        id: 14,
      },
      {
        title: 'Swirls',
        prompt:
          'swirly minimalist artstation iphone background by victo ngai, kilian eng and by jake parker vibrant colors, winning-award masterpiece, fantastically gaudy, aesthetic octane render, 8k hd resolution',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/ec32f327-273d-4aa4-9b00-fc430d1ead26.png',
        id: 15,
      },
      {
        title: 'Colorful pattern',
        prompt: 'Colorful spring pattern,  Watercolor painting on a white paper, white background',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/71044c72-3a41-4171-a5a0-333d303fcdcb.png',
        id: 16,
      },
      {
        title: 'Retrofuturism',
        prompt: 'A graph style guach impasto mouse, art by james gilleard, cgsociety, retrofuturism, retrowave, outrun.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/0c0dca23-3ada-41e9-b192-906ffa580036.png',
        id: 17,
      },
      {
        title: 'Whimsical',
        prompt: 'Painting with a playful and whimsical feel, featuring bright colors and simple, flowing shapes like figures',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/0ebefbe8-af83-49db-8814-0c4916845b01.png',
        id: 18,
      },
      {
        title: 'Cloudy',
        prompt: 'An illustration of many colorful clouds, a minimalist painting, featured on dribble, geometric abstract art',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/9aa96f5e-8089-4995-a129-393b1beafad1.png',
        id: 19,
      },
      {
        title: 'Pointilism',
        prompt: 'Spotty pointism,, colored spots, mixed liquid acrylic, painting come to life, artstation, ultradetail',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/92400b78-3a12-4855-88ef-d77181f0fe26.png',
        id: 20,
      },
      {
        title: 'Magic',
        prompt:
          'Magic background game design with miss pokemon woolly :: painting overlay by beeple by raffaello sanzi and chao teng zhao :: centered, pixar and dremwork artstation, smooth, sharp focus, octane render, 3d rim light',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/876b4316-0ce1-4e40-b423-fbb8d83ea97b.png',
        id: 21,
      },
      {
        title: 'Minimalist Poster',
        prompt: 'An abstract minimalistic composition using geometric shapes in shades of yellow and green, a hand-drawn line art flowers',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/9a85116f-3608-42a9-99fd-4e440f0ce89a.png',
        id: 22,
      },
      {
        title: 'Colorful ink',
        prompt: 'Fluid minimalist wallpaper with l alcohol ink.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/341b7f59-dff5-4470-8c4c-51a3593b9579.png',
        id: 23,
      },
      {
        title: 'Holographic',
        prompt: 'holographic Color pigments spread out in water, look like dancing, dream, unreal 5, trending on artstation, soft colors',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/4a9e98d7-d74b-4ae5-bf88-2573e4e3a882.png',
        id: 24,
      },
      {
        title: 'Sci-Fi Landscape',
        prompt:
          'Landscape, style of laurie greasley, studio ghibli, akira toriyama, james gilleard, genshin impact, trending pixiv fanbox, acrylic palette knife, 4k, vibrant colors, devinart, trending on artstation, low details',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/fa3d0c65-7e17-447b-973d-9a9438efa46d.png',
        id: 25,
      },
      {
        title: 'Splatter',
        prompt: 'abstract art piece with brushstrokes and splatters.',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/9ee78802-2f32-43cd-8f3e-4e13e9542e2e.png',
        id: 26,
      },
      {
        title: 'Striped',
        prompt: 'horizontal,soft striped, Minimalist painting in neutral tones of straps, water, with colors',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/b09e9547-2958-493c-b656-b2347e2a358c.png',
        id: 27,
      },
      {
        title: 'Vibrant painting',
        prompt: 'abstract by atey ghailan + edward hopper bautiful color',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/659d0368-34f4-4114-8518-993c1ee5a9e7.png',
        id: 28,
      },
      {
        title: 'Wood',
        prompt: 'painted wood panels wall texture',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/70465874-b999-40fb-ba0d-60f87b616a1f.png',
        id: 29,
      },
      {
        title: 'Chromatic',
        prompt: 'Move still from morn to midnight, award winning oil painting, iridescent color palette ( chromatic aberration )',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/6812eb42-94a0-4ffd-b7a2-9d4a8e00d531.png',
        id: 30,
      },
      {
        title: 'Bricks',
        prompt: ' painted brick texture',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/7656a793-2b5c-49ae-b038-b9ab580946de.png',
        id: 31,
      },
      {
        title: 'Stained paper',
        prompt: 'watercolor stained paper texture',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/9f258b59-30f5-4401-be6a-fd09c06ae7d0.png',
        id: 32,
      },
      {
        title: 'Fine art',
        prompt: 'a serene landscape painting, by j. m. w. turner',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/e47908e5-e8b6-4c7d-8add-a3d0414c31c7.png',
        id: 33,
      },
      {
        title: 'Abstract poster',
        prompt: 'Poster art by tomokazu matsuyama, featured on pixiv, space art, 2d game art, cosmic, official art',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/81e312cc-56bc-47e1-b551-a2444fdb9a23.png',
        id: 34,
      },
      {
        title: 'Mondrian',
        prompt: 'abstract background, by piet mondrian, expressive, lines',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/80f59a10-3c21-4a31-bf55-d3d13b02f267.png',
        id: 35,
      },
      {
        title: 'Monet',
        prompt: 'background, by monet, expressive, beautiful',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/37f4cbba-d3b9-45cd-b45c-fd8f2351290b.png',
        id: 36,
      },
      {
        title: 'Doodle',
        prompt: 'background, doodle, expressive, sketch, pencil, cool, well drawn',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/59bb940a-0c76-4a2b-a910-a3f5015d0ffb.png',
        id: 37,
      },
      {
        title: 'Gradient shapes',
        prompt: 'A minimal abstract wallpaper,colorful,  behance, artstation, deviantart, global illumination',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/fab271bf-9bb7-4d90-8a6f-a6c3f838450f.png',
        id: 38,
      },
      {
        title: 'Sci Fi',
        prompt: ' by wlop, james jean, victo ngai! muted colors, very detailed, art fantasy by craig mullins, thomas kinkade',
        thumbnail: 'https://pastatic.picsart.com/cms-pastatic/1d27e246-8218-4a7c-9b95-1538102e6cc9.png',
        id: 39,
      },
    ],
  },
  usage_limitation_config: {
    should_show_offer: false,
    pro: {
      title: 'Daily limit reached',
      description: 'Come back tomorrow to enjoy more of the AI Image Generator.',
      primary_button_title: 'Close',
      limit: 1000,
      expiration_time_interval: 86400,
      is_enabled: false,
    },
    plus: {
      title: 'Daily limit reached',
      description: 'Come back tomorrow to enjoy more of the AI Image Generator.',
      primary_button_title: 'Close',
      limit: 10,
      expiration_time_interval: 86400,
      is_enabled: false,
    },
    max: {
      title: 'Daily limit reached',
      description: 'Come back tomorrow to enjoy more of the AI Image Generator.',
      primary_button_title: 'Close',
      limit: 1000,
      expiration_time_interval: 86400,
      is_enabled: false,
    },
    old_gold: {
      title: 'Daily limit reached__',
      description: 'Come back tomorrow to enjoy more of the AI Image Generator.',
      primary_button_title: 'Close',
      limit: 1000,
      expiration_time_interval: 86400,
      is_enabled: false,
    },
    free: {
      title: 'Daily limit reached',
      description: 'Come back tomorrow to enjoy more of the AI Image Generator.',
      primary_button_title: 'Close',
      limit: 5,
      expiration_time_interval: 86400,
      is_enabled: true,
    },
  },
  transparency_check_config: {
    is_enabled: true,
    lower_bound: 5,
    upper_bound: 85,
  },
  service_config: {
    batch_size: 4,
    t2b_service_url: '/editor-tools/avatars/t2i',
    t2b_ai_service_path: '/text-to-image-middleware/v4/task/',
    visibility_service_url: '/editor-tools/avatars/t2i/public',
    visibility_path: '/v1/photos/visibility',
    service_path: 'v2/task/',
    model_version: 'V21',
    task_type: 'PHOTOREALISTIC13',
    negative_prompt: 'text, watermark, username, low quality, worst quality, deformed, disfigured, low resolution, out of frame, deformed, duplicate, blurry, lowres, jpeg artifacts',
    hidden_prompt: 'image, high quality',
  },
  errors: {
    no_internet: 'No internet Connection',
    service_error: 'Something went wrong. Please try again later.',
  },
};
